import { ReviewsIoStoreId } from 'config/constants/reviews-io';
import sharedEnvironment from 'config/shared-environment';
import { ShopId } from 'constants/shop';

const TRUSTED_SHOPS_ID = 'XF6F29E67F210CC76FD76E9BD556839EB';

/**
 * Environment values shared by dev, staging and production for the DE shop.
 */
// TODO: common env should be placed in the root of the config per locale
export default {
  ...sharedEnvironment,
  cookieDomain: '.petsdeli.de',
  currencyCode: 'EUR',
  shopId: ShopId.DE,
  trustedShopsId: TRUSTED_SHOPS_ID,
  trustedShopsUrl: `https://www.trustedshops.de/bewertung/info_${TRUSTED_SHOPS_ID}.html`,
  reviewsIoStoreId: ReviewsIoStoreId.DE,
};
